import { Injectable } from '@angular/core';
import { ApiConfigService } from './api-config.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BrandItem } from '../../models/brand.interface';

@Injectable({
  providedIn: 'root'
})
export class BrandService {
  private get apiUrl(): string { return `${this.apiConfig.apiUrl}/brands`; }

  constructor(private http: HttpClient, private apiConfig: ApiConfigService) {}

  getBrands(): Observable<BrandItem[]> {
    return this.http.get<BrandItem[]>(this.apiUrl);
  }

  createBrand(data: Partial<BrandItem>): Observable<BrandItem> {
    return this.http.post<BrandItem>(this.apiUrl, data);
  }

  updateBrand(id: string, data: Partial<BrandItem>): Observable<BrandItem> {
    return this.http.put<BrandItem>(`${this.apiUrl}/${id}`, data);
  }

  deleteBrand(id: string): Observable<{ message: string }> {
    return this.http.delete<{ message: string }>(`${this.apiUrl}/${id}`);
  }
}



